<template>
  <section class="benefits-orthodontics container p-md-5 mt-md-5 ">
    <Title title="مراحل انجام کار"></Title>
    <div class="benefits-orthodontics-img d-md-block d-none mt-5 pt-4 mx-auto"><img src="@/assets/images/others/steps.svg" alt=""></div>
    <div class="benefits-orthodontics-img d-md-none mt-5 pt-4 mx-auto"><img src="@/assets/images/others/stepsJobResp.svg" alt=""></div>
  </section>
</template>

<script>
import Title from "./Title";
export default {
  name: "StepsJob",
  components:{
    Title
  }
}
</script>

<style scoped>
.benefits-orthodontics-img{
  width: 60%;
  height: auto;
}
.benefits-orthodontics-img img{
  width: 100%;
}
@media screen and (max-width: 991px) {
  .benefits-orthodontics-img {
    width: 80%;
  }
}
@media screen and (max-width: 767px) {
  .benefits-orthodontics-img {
    width: 90%;
  }
}
</style>